export default __webpack_public_path__ + "static/media/responsive.796417b2.png";